import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "column is-flex is-flex-direction-column is-11",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "is-flex is-justify-content-space-between" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "icon-text is-size-4 is-size-6-mobile" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("wbr", null, null, -1)
const _hoisted_6 = { class: "ml-3 has-text-right is-size-5 is-size-6-mobile" }
const _hoisted_7 = { class: "icon-text is-flex-wrap-nowrap" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon",
  style: {"color":"orange"}
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-star" })
], -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "is-11 column" }
const _hoisted_11 = { class: "mb-5 is-size-5 is-size-6-mobile" }
const _hoisted_12 = {
  key: 0,
  class: "is-11 is-flex is-flex-direction-column column"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-code-branch" })
], -1)
const _hoisted_14 = ["href"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" - ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            href: _ctx.repo.url
          }, [
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.repo.nameWithOwner.split('/')[0]) + "/", 1),
              _hoisted_5,
              _createTextVNode(_toDisplayString(_ctx.repo.nameWithOwner.split('/')[1]), 1)
            ])
          ], 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", null, _toDisplayString(_ctx.repo.stargazers.totalCount), 1)
            ])
          ]),
          (_ctx.repo.primaryLanguage)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                style: _normalizeStyle({color: _ctx.repo.primaryLanguage.color})
              }, _toDisplayString(_ctx.repo.primaryLanguage.name), 5))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, "Unknown"))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.repo.description), 1),
      (_ctx.pulls)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pulls, (pull) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "icon-text is-flex-wrap-nowrap mb-5 is-size-5 is-size-7-mobile",
                key: pull.number
              }, [
                _hoisted_13,
                _createElementVNode("span", null, [
                  _createElementVNode("a", {
                    href: pull.url
                  }, "#" + _toDisplayString(pull.number), 9, _hoisted_14),
                  _hoisted_15,
                  _createElementVNode("span", null, _toDisplayString(pull.title), 1)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}